<template>
  <div class="content-box">

    <div v-if="showImg" class="img-view">
        <div @click="closeImg" class="img-layer"></div>
        <div class="img">
            <img :src="imgSrc">
        </div>
    </div>
    

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
          <el-breadcrumb-item>搜索結果</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>



    <div class="content">
        <div class="jg-head">
            <div class="jg-img">
                <img :src="sourceurl+bookinfo.frontpage">
            </div>
            <div class="jg-container">
                <div class="jg-title">{{bookinfo.bookname}}</div>
                <div class="jg-row">
                    <div class="s-jg">
                        <span class="s-jg-name">作者：</span>
                        <span class="s-jg-value">{{bookinfo.bookauthor}}</span>
                    </div>
                    <div class="s-jg">
                        <span class="s-jg-name">出版社：</span>
                        <span class="s-jg-value">{{bookinfo.publisher}}</span>
                    </div>
                </div>
                <div class="jg-row">
                    <div class="s-jg">
                        <span class="s-jg-name">出版日期：</span>
                        <span class="s-jg-value">{{bookinfo.publish_date}}</span>
                    </div>
                    <div class="s-jg">
                        <span class="s-jg-name">主題詞：</span>
                        <span class="s-jg-value">{{bookinfo.title_keyword}}</span>
                    </div>
                </div>
                <div class="jg-row">
                    <div class="s-jg">
                        <span class="s-jg-name">版次：</span>
                        <span class="s-jg-value">{{bookinfo.edition}}</span>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="nrjj-box">
            <div class="nrjj">
                <span>內容簡介</span>
                <img src="../assets/icon/line.png">
            </div>
            <div class="nrjj-content">
                <span>{{bookinfo.content}}</span>
            </div>
        </div>

        <div class="ydwd">
            <div>閱讀文檔</div>
            <img src="../assets/icon/line.png">
            
        </div>
        <div class="ydwd-container">
            <div class="ydwd-img">
                <div class="bg-img" @click="openImg(bookpageurl)" :style="{backgroundImage:'url('+bookpageurl+')'}">

                  <el-button class="left-pagging"   @click="prepage()">
                    <i class='el-icon-arrow-left'></i>
                  </el-button>

                  
                  <el-button class="right-pagging"  @click="nextpage()">
                    <i class='el-icon-arrow-right'></i>
                  </el-button>

                </div>
                 
                
                    <div style="text-align: center;margin-top: 30px;">
                        <el-pagination
                            background
                            :current-page="currentpage"
                            :page-size="1"
                            layout="total, prev, pager, next, jumper"
                            :total="totalcount"
                            @current-change="current_change">
                        </el-pagination>
                    </div>
            </div>
            <div class="ydwd-detail">
                <div class="detail-btn">
                    <div @click="clicktab(0)" :style="bgcolor0" class="wdml">文檔目錄</div>
                    <div @click="clicktab(1)" :style="bgcolor1" class="wdbj">我的筆記</div>
                </div>
                <div v-if="mytab==0" class="detail-content">

                    <div class="detail-box">
                        <div class="detail-text">"{{bookinfo.bookname}}"</div>
                        <div class="detail-cata">


                           <el-menu
                            class="el-menu-vertical-demo"
                            @open="handleOpen"
                            @close="handleClose">
                            <div class="catalog-item" v-for="catalog in cataloglist" :key="catalog"  @click="cataclick(`${catalog.page}`,`${catalog.ID}`)" :index="catalog.ID">
                              <a class="catalog-link" style="text-decoration: none;" >
                                <span v-if="catalog.ctype>1" slot="title">  </span>
                                <span slot="title">{{catalog.ctitle}}</span>
                                <span slot="title">{{catalog.etitle}}</span>
                              </a>
                              
                            </div>
                          </el-menu>

                        </div>
                    </div>

                   
                </div>


                <div v-if="mytab==1" class="detail-content">
                  <div v-if="notelist.length<1">

                    <div  class="detail-box">
                        <div class="detail-text">此處為筆記</div>
                        <div class="detail-note">
                            <span>筆記：</span>
                            <span>此表格數據可以參考</span>
                        </div>
                        <div class="note-btns">
                            
                            <el-button  @click="addnote(0)">
                                <i class='el-icon-document-add'></i>
                            </el-button>
                        </div>
                         
                    </div>

                  </div>

                    
                    <div v-for="note in notelist" :key="note" class="detail-box">
                        <div class="detail-time">
                            {{note.ntime}}
                        </div>
                        <div class="detail-text">{{note.nmessage}}</div>
                        <div class="detail-note">
                            <span>筆記：</span>
                            <span>此表格數據可以參考</span>
                        </div>
                        <div class="note-btns">
                            
                            <el-button  @click="addnote(0)">
                                <i class='el-icon-document-add'></i>
                            </el-button>
                            <el-button  @click="editnote(note.ID,note.nmessage)">
                             <i class='el-icon-edit'></i>
                            </el-button>
                            <el-button @click="delnote(note.ID)">
                                <i class='el-icon-document-remove'></i>
                            </el-button>
                        </div>
                         
                    </div>



                </div>






            </div>
        </div>

    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      sourceurl:'',
      id:this.$route.query.bid,
      bookinfo:[],
      bookid:1,
      totalcount:0,
      currentpage:1,
      bookpageurl:"../assets/bookpage/第1册/第1册_00.png",
      mytab:0,
      bgcolor0:"background-color: #c60828",
      bgcolor1:"background-color: #dc9fa3",
      cataloglist:[],//目录列表
      notelist:[],//笔记列表
      pagecount:0,
      //sourceurl:"",
      noteform: {
          noteid: '',
          uid: '',
          username:'',
          bookid: '',
          bookpage: '',
          t:'',
          msg:'',
          ustring:'',
        },

      pshowImg:false,
      imgSrc:"",
    };

  },
  methods: {
    openImg(a) {
      this.pshowImg = true;
      // 获取当前图片地址
      this.imgSrc = a;
      //console.log("图片:"+this.imgSrc);
    },
    closeImg(){
      this.pshowImg = false;
    },



    prepage(){
      if(this.currentpage>1){
        this.currentpage--;

      }
      //this.currentpage=val;
      this.pagging();

    },
    nextpage(){
      if(this.currentpage<this.pagecount){
        this.currentpage++;
      }
      //this.currentpage=val;
      this.pagging();
      

    },



      addnote() {
        //alert(window.sessionStorage.getItem('hguid'));
        if(window.sessionStorage.getItem('hguid')==null||window.sessionStorage.getItem('hguser')==null){
          this.$message({
            type: 'info',
            message: '請登錄！'
          });
          return;
        }
        this.$prompt('筆記內容', '新增筆記', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          inputPattern: /^.*$/,
          inputErrorMessage: '筆記內容不能為空'
        }).then(({ value }) => {
          this.noteform.msg=value;
          this.noteform.uid=window.sessionStorage.getItem('hguid');
          this.noteform.username=window.sessionStorage.getItem('hguser');
          this.noteform.bookid=this.bookid;
          this.noteform.bookpage=this.currentpage;
          this.noteform.ustring=window.sessionStorage.getItem('hguser');
          this.noteform.t="add";
          

          this.$http
          .post(`${this.$store.state.baseurl}/api/hgbooknote/notefun`,this.noteform)
          .then((res) => {
            let json = res.data;
            let uinfo=JSON.parse(json);
            this.$message({
              type: 'success',
              message: uinfo.error
            });
            this.$router.go(0);
          });
          
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消筆記'
          });       
        });
      },

      editnote(id,msg) {
        this.$prompt('筆記內容', '修改筆記', {
          confirmButtonText: '保存',
          inputValue:msg,
          cancelButtonText: '取消',
          inputPattern: /^.*$/,
          inputErrorMessage: '筆記內容不能為空'
        }).then(({ value }) => {
          this.noteform.noteid=id;
          this.noteform.msg=value;
          this.noteform.uid=window.sessionStorage.getItem('hguid');
          this.noteform.ustring=window.sessionStorage.getItem('hguser');
          this.noteform.bookid=this.bookid;
          this.noteform.bookpage=this.currentpage;
          this.noteform.t="edit";

          this.$http
          .post(`${this.$store.state.baseurl}/api/hgbooknote/notefun`,this.noteform)
          .then((res) => {
            let json = res.data;
            let uinfo=JSON.parse(json);
            this.$message({
              type: 'success',
              message: uinfo.error
            });
            this.$router.go(0);
            
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消修改'
          });       
        });
      },
      delnote(id) {
        //console.log("eeeeee:"+id);
        this.$confirm('此操作將永久刪除該文件, 是否繼續?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.noteform.bookid=this.bookid;
          this.noteform.bookpage=this.currentpage;
          this.noteform.noteid=id;
          this.noteform.msg="";
          this.noteform.uid=window.sessionStorage.getItem('hguid');
          this.noteform.ustring=window.sessionStorage.getItem('hguser');
          this.noteform.t="del";
          this.$http
          .post(`${this.$store.state.baseurl}/api/hgbooknote/notefun`,this.noteform)
          .then((res) => {
            let json = res.data;
            let uinfo=JSON.parse(json);
            this.$message({
              type: 'success',
              message: uinfo.error
            });

            this.$router.go(0);
          });
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消刪除'
          });
        });
        
      },
      //点击目录切换
      cataclick(page,lid){
        //var cssobj=document.getElementsByClassName("");
        //cssobj.item.
       // $('')
          //document.getElementsByClassName('.catalog-link').style.color = '#000000';
          this.currentpage=page;
          this.pagging();

      },
      
      //
      current_change(val){
      this.currentpage=val;
      //this.pageSize=val;
      var rcode=window.sessionStorage.getItem('hgcode');
      if(rcode!=null){
        this.pagging();
      }
      else{
        this.$message('请登錄！');
      }

      //this.pagging();
      },
      //切换
      clicktab(a){
          this.mytab=a;
          
          if(a==1){
            this.bgcolor0="background-color: #dc9fa3";
            this.bgcolor1="background-color: #c60828";
          }
          if(a==0){
            this.bgcolor0="background-color: #c60828";
            this.bgcolor1="background-color:#dc9fa3";
          }
          //console.log("mytab:"+bgcolor0);
      },
      setpage(p){
      let pa="";
      if(p<10){
        pa="0"+p;
      }
      else{
        pa=p;
      }

      return pa;
    },
    //翻页
    pagging(){

      if((window.sessionStorage.getItem('hguid')==null||window.sessionStorage.getItem('hguser')==null)&&this.currentpage>1){
          this.$message({
            type: 'info',
            message: '請登錄！'
          });
          return;
        }


        this.$http
      .get(`${this.$store.state.baseurl}/api/hgbookreadediter/getpagedata?page=`+this.currentpage+'&bookid='+this.bookid)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.pagecount=pinfo.dataSize;

        this.bookpageurl=`${this.$store.state.sourceurl}`+pinfo.data[0].pre10+this.setpage(parseInt(this.currentpage)+parseInt(pinfo.data[0].pre8))+".png";//pinfo.data[0].pre10+this.currentpage+".png";
        this.totalcount=parseInt(pinfo.data[0].pre9)-2;
        
      });

      let userid=window.sessionStorage.getItem('hguid');
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgbooknote/getnotelist?bookid=`+this.bookid+"&uid="+userid+"&bookpage="+this.currentpage)
      .then((res) => {
        const json = res.data;
        this.notelist = JSON.parse(json).data;
        
        
      });

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    this.sourceurl=`${this.$store.state.sourceurl}../..`;
    //获取当前条目ID号
    //id = this.$route.params.id;this.$route.query;
    this.bookid=this.$route.query.bid;
    //console.log("44444"+this.$route.query.id);
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgbookread/getbookinfo?id=`+this.id)
      .then((res) => {
        const json = res.data;
        this.bookinfo = JSON.parse(json).data[0];
        //this.bookid=this.bookinfo.ID;
        
        this.cataloglist=JSON.parse(json).data2;
        this.pagging();
        
      });

      
  },
};
</script>

<style scoped lang="scss">

.img-view {
    position: relative;
    width: 100%;
    height: 100%;
}
.ydwd-container{
    margin: 15px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    .ydwd-img{
            width: 800px;
            height:1200px;
            
        .bg-img{
            background-repeat: no-repeat;
            background-size: 100% 100%;
            -moz-background-size: 100% 100%;
            width: 800px;
            height:1100px;
            background-color:#ffffff;
            .left-pagging{
              float: left;
              margin-top: 500px;
              width: 90px;
              height: 60px;
              opacity: 0.5;

            }
            .pagging-prog{
              margin-top: 500px;
              width: 90px;
              height: 90px;
            }
            .right-pagging{
              float: right;
              margin-top: 500px;
              width: 90px;
              height: 60px;
              opacity: 0.5;
            }
        }
    }
    .ydwd-detail{
        margin-left: 15px;
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        .detail-btn{
            .wdml{
                width: 30px;
                height: 85px;
                background-color: #dc9fa3;
                padding: 15px 5px;
                margin-bottom: 5px;
                border-radius: 5px 0px 0px 5px;
                cursor:pointer;
            }
            .wdbj{
                width:30px;
                height: 85px;
                padding: 15px 5px;
                background-color: #c60828;
                border-radius: 5px 0px 0px 5px;
                cursor:pointer;
            }
        }
        .detail-content{
          overflow:auto;
            width: 300px;
            height: 1100px;
            background-color: #f7f6f4;
            .detail-box{
                text-align: left;
                padding: 15px;
                width:250px;
                margin:10px;
                background-color: #fcfcfc;
                border:1px solid #dacec4;
                border-radius: 5px;
                color: #666666;
                .cata-box{
                    margin-top: 10px;
                    cursor:pointer;
                }
                .note-btns{
                    text-align: right;
                    margin-top: 20px;
                }
                .detail-text{
                    border-bottom:1px dashed #dacec4;
                    padding: 15px;
                    margin-bottom: 10px;
                }
            }
        }
    }
}
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
  border-style: solid;
  border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  .jg-head{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .jg-img{
          margin: 30px;
          width: 200px;
          height: 200px;
          background-color: #ffffff;
          img{
              margin-top: 20px;
              width: 120px;
              height: 160px;
          }
      }
      .jg-container{
          margin-top: 30px;
          width: 900px;
          text-align: left;
          .jg-title{
              margin-bottom: 20px;
              font-size: 28px;
              color: #333333;
          }
          .jg-row{
              width: 860px;
              margin:10px 0px 10px 15px;
              display: flex;
              flex-direction: row;
              justify-content: start;
              flex-wrap: wrap;
              .s-jg{
                  width: 350px;
                  color: #666666;
                  font-size: 14px;
                  .s-jg-name{
                      margin: 0px 5px;
                  }
                  .s-jg-value{
                      margin: 0px 5px;
                  }
              }
          }
      }
  }
  .nrjj-box{
      text-align: left;
      .nrjj{
          span{
              color: #c60828;
              font-size: 18px;
          }
          img{
              width:400px;
              height: 20px;;
          }
      }
      .nrjj-content{
          margin: 15px;
          width: 1160px;
          font-size: 14px;
          line-height: 1.5em;
          letter-spacing: 1.5px;
          color: #333333;
          span{
              color: #333333;
          }
      }
  }
  .ydwd{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      div{
          color: #c60828;
          font-size: 18px;
      }
      img{
          width:400px;
          height:20px;
      }
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.catalog-item{
  margin-top: 10px;
  cursor: pointer;
  word-break: break-all;

  a:hover
  {
      color: #888866; /* 文字颜色 */
      text-decoration: none; /* 不显示超链接下划线 */
  }
  a:active
  {
      color: #333333; /* 文字颜色 */
      text-decoration: none; /* 不显示超链接下划线 */
  }
}



</style>